import React, { useEffect, useState } from 'react';
import { FxmsData } from "../../datas/FxData";
import { AlarmColor, AlarmLevel } from "../../datas/ColorData"

/* 관리대상 상세 - 이벤트 */
export const FxAlarmDetail = (props) => {
  const { datas } = props;
  const [activeButtonIndex, setActiveButtonIndex] = useState(2);
  const [dataList, setDataList] = useState(null);
  const [dateType, setDateType] = useState("WEEK");
  const [loading, setLoading] = useState(true);

  console.log("dataList>>", dataList);

  useEffect(() => {
    setLoading(true);

    async function getDataList() {
      try {
        const param = {
          moTid: datas.moTid,
          dateType: dateType //NOW,YESTERDAY,WEEK,MONTH,YEAR
        }
        const uri = "fxMo/detail/event"
        const response = await FxmsData.GET(uri, param);
        console.log("event response >>>", response.data)
        setDataList(response.data)
        setLoading(false); 
      } catch (error) {
        console.log("error : " + error);
        setLoading(false);
      }
    }

    if (datas.moTid !== undefined && datas.moTid !== "") {
      getDataList();
    } else {
      setLoading(false); // 조건이 만족되지 않으면 로딩 상태를 false로 설정
    }
  }, [dateType])

  useEffect(() => {
  }, [dataList])

  const buttonList = [
    { text: "현재", className: "mngtg", dateType: "NOW" },
    { text: "오늘", className: "mngtg", dateType: "TODAY" },
    { text: "지난 7일", className: "mngtg", dateType: "WEEK" },
    { text: "지난 1개월", className: "mngtg", dateType: "MONTH" },
    { text: "지난 1년", className: "mngtg", dateType: "YEAR" },
  ]

  const handleClick = (index, dateType) => {
    setActiveButtonIndex(index);
    setDateType(dateType);
  }

  const handleAlarm = (inputLevel) => {
    let temp = {};
    let alarmName = AlarmLevel.getName(inputLevel);
    let alarmColor = AlarmColor.getColor(inputLevel);

    temp = {
      alarmName: alarmName,
      alarmColor: { backgroundColor: alarmColor }
    };

    return temp;
  }

  return (
    <>
      <ul>
        {buttonList.map((button, index) => (
          <li
            key={index}
            className={index === activeButtonIndex ? "mngtgOn" : "mngtg"}
            onClick={() => handleClick(index, button.dateType)}
          >
            {button.text}
          </li>
        ))}
        <span className="mngtg">
          발생건수 : {(dataList && dataList.length.toLocaleString("ko-KR")) || 0}
        </span>
      </ul>
      <div className="tableData" >
        <table className="mngtg">
          <colgroup>
            <col style={{ width: "10%" }} />
            <col style={{ width: "14%" }} />
            <col style={{ width: "14%" }} />
            <col style={{ width: "10%" }} />
            <col style={{ width: "*" }} />
            <col style={{ width: "13%" }} />
          </colgroup>
          <tbody>
            <tr >
              <th >등급</th>
              <th >발생시기</th>
              <th >해제일시</th>
              <th >알람명</th>
              <th >알람메세지</th>
              <th >지속시간</th>
            </tr>

            {loading ? (
              <tr>
                {/* <td colSpan="6" rowSpan="2" style={{ fontSize: '16px', color: '#999999' }}>Loading data...</td> */}
                <td colSpan="6">
                  <span className="loading-icon"></span>
                </td>
              </tr>
            ) : (
              dataList && dataList.length > 0 ? (
                dataList.map((data, index) => {
                  const { alarmColor, alarmName } = handleAlarm(data.alarmLevel);
                  return (
                    <tr key={index}>
                      <td style={alarmColor}>{alarmName}</td>
                      <td>{data.occurDtm}</td>
                      <td>{data.rlseDtm}</td>
                      <td style={{ textAlign: "left" }}>{data.alcdName}</td>
                      <td style={{ textAlign: "left" }}>{data.alarmMsg}</td>
                      <td>{data.duration}</td>
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td colSpan="6" style={{ fontSize: '16px', color: '#999999' }}>데이터가 존재하지 않습니다</td>
                </tr>
              )
            )}
          </tbody>
        </table>
      </div>

    </>
  );
};

